
import WrapComponents from "./WrapComponents.vue";
import WrapFlex from "./WrapFlex.vue";
import { mapState } from "vuex";
import { message as alertMessage } from "ant-design-vue";
// import Start from "../../public/Vector.png";
export default {
  components: {
    WrapComponents,
    WrapFlex,
  },
  computed: {
    ...mapState(["userInfo", "loggedIn"]),
    ...mapState("SchoolAccount", ["accountSchoolId", "userRole"]),
    displayName() {
      try {
        console.log(this.userInfo);
        return (
          this.userInfo?.info?.name ||
          this.userInfo?.info?.phone ||
          (this.userInfo?.info?.email
            ? this.userInfo.info.email.split("@")[0]
            : "Tài khoản")
        );
      } catch (e) {
        return "Tài khoản";
      }
    },
    maskedSecondary() {
      const email = this.userInfo?.info?.email || "";
      const phone = this.userInfo?.info?.phone || "";
      if (email) return this.maskEmail(email);
      if (phone) return this.maskPhone(phone);
      return "";
    },
  },
  watch: {
    "$route.query.p": {
      handler: function (p) {
        this.isMobileMenuOpen = false;
      },
      deep: true,
      immediate: true,
    },
    "$store.state.Chat.list_room"(value, _) {
      this.handleNotify(value);
    },
    loggedIn() {
      if (this.loggedIn) {
        const memberId = this.userInfo.info.id;
        this.$store.dispatch("SchoolAccount/getUserRole", {
          memberId,
        });
        this.$store.dispatch("getListSchoolSaved");
        // Fetch notifications when user logs in
        this.fetchNotifications();
      } else {
        this.$store.commit("SET_LIST_SCHOOL_SAVED", []);
        this.$store.commit("SchoolAccount/SET_USER_ROLE", {
          school_id: "",
          table: "",
        });
        // Clear notifications when user logs out
        this.notifications = [];
        this.unseen_message_counter = 0;
      }
    },
  },
  data() {
    return {
      isMobileMenuOpen: false,
      isAvatarMenuOpen: false,
      isNotifyOpen: false,
      isOpenNoti: false,
      isNotifyDropdownOpen: false,
      notificationsLoading: false,
      notifications: [],
      showAllViewedMessage: false,
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      BASE_URL_AUTH_REDIRECT: this.$config.BASE_URL_AUTH_REDIRECT,
      BASE_URL_CLIENT: this.$config.BASE_URL_CLIENT,
      BASE_URL_SSO: this.$config.BASE_URL_SSO,
      BASE_URL_NOTIFICATION: `${this.$config.BASE_URL_CLIENT}/api/notification`,
      unseen_message_counter: 0,
      // mockNotifications: [
      //   { title: 'Thông báo', text: 'Từ ngày 01.02.2024, tất cả số Sao của bạn sẽ...', time: '14:00  Hôm nay' },
      //   { title: 'Sự kiện sắp bắt đầu', text: 'Sự kiện Ngày Không Tiền Mặt...', time: '14:00  20/12/2024' },
      //   { title: 'Giao dịch thành công', text: 'Bạn đã mua thành công 500 Sao...', time: '14:00  28/11/2025' }
      // ],
    };
  },
  async mounted() {
    window.openLoginForm = this.showModal;
    this.handleNotify(this.$store.state.Chat.list_room);

    // Fetch notifications immediately if user is logged in
    if (this.loggedIn) {
      await this.fetchNotifications();
    }

    // Check if user is not logged in but might have valid cookies
    // if (!this.loggedIn && !this.userInfo.info?.id) {
    //   console.log("Attempting client-side authentication...");
    //   await this.$store.dispatch("authenticateClient");
    // }

    // Log logo URL for debugging
  },
  methods: {
    openLink() {
      window.open("https://mediahub.tuoitre.vn/sao#goi-mua", "_blank");
    },
    openDiemThi() {
      try {
        if (typeof window !== "undefined") {
          window.open("https://tuoitre.vn/diem-thi.htm", "_blank");
        }
      } catch (e) {
        // ignore
      }
    },
    handleNotify(list_room) {
      if (list_room && list_room.length > 0) {
        this.unseen_message_counter = list_room.reduce((previous, current) => {
          return previous + current.unseen_message;
        }, 0);
      }
    },
    setDefaultMajorPage() {
      if (window.setMajorPage) {
        window.setMajorPage("ListMajor");
      }
    },
    hideMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    showModal() {
      const urlRedirectLogin = `${
        this.BASE_URL_AUTH_REDIRECT
      }/auth/login?redirectUrl=${encodeURI(
        `${this.BASE_URL_CLIENT}${this.$route.fullPath}`,
      )}`;
      window.location.href = urlRedirectLogin;
      return;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },

    // On mobile, clicking the avatar should open the mobile menu (like the 3-bar button)
    onAvatarClick() {
      try {
        if (typeof window !== "undefined" && window.innerWidth <= 760) {
          // open a small avatar dropdown (separate from the full mobile menu)
          this.isAvatarMenuOpen = !this.isAvatarMenuOpen;
          // ensure mobile menu closed
          this.isMobileMenuOpen = false;
          return;
        }
        // otherwise (desktop) let dropdown handle it
      } catch (e) {
        // ignore
      }
    },
    toggleNotify() {
      this.isNotifyOpen = !this.isNotifyOpen;
      // if (this.isNotifyOpen) {
      //   this.isMobileMenuOpen = false;
      //   this.isAvatarMenuOpen = false;
      // }
    },

    closeMenus() {
      this.isMobileMenuOpen = false;
      this.isAvatarMenuOpen = false;
    },

    handleLogout() {
      alertMessage.loading({ content: "Đang đăng xuất ...", key: "logout" });
      // this.$store.dispatch("logout");
      this.$store.dispatch("logout");
      if (this.$route.path === "/user") {
        this.$router.push("/");
      }
    },
    // Resolve avatar URL: if avatar is a full URL, return it; if it's a relative path stored in storage, prefix BASE_URL_STATIC; fallback to default icon
    getAvatarUrl(avatar) {
      const fallback = "https://cdn-mediahub.tuoitre.vn/icons/user.svg";
      if (!avatar) return fallback;
      try {
        // if avatar looks like an absolute URL (http/https) return as-is
        if (/^https?:\/\//i.test(avatar)) return avatar;
        // if avatar starts with a slash, treat as absolute path on the site
        if (/^\//.test(avatar)) return avatar;
        // otherwise assume it's a storage path and prefix BASE_URL_STATIC
        return `${this.BASE_URL_STATIC}/${avatar}`;
      } catch (e) {
        return fallback;
      }
    },
    // Handle notify dropdown open/close
    async handleNotifyDropdownChange(visible) {
      this.isNotifyDropdownOpen = visible;
      if (visible && this.loggedIn) {
        await this.fetchNotifications();
      }
    },
    // Mask helpers
    maskEmail(email) {
      try {
        const [local] = String(email).split("@");
        // Hiển thị toàn bộ phần local và ẩn toàn bộ phần domain
        return `${local}*****`;
      } catch (e) {
        return "***";
      }
    },
    maskPhone(phone) {
      const p = String(phone || "");
      if (p.length <= 3) return `${p}***`;
      const head = p.slice(0, 3);
      const tail = p.slice(-2);
      return `${head}****${tail}`;
    },
    // Fetch notifications from API
    async fetchNotifications() {
      if (!this.loggedIn) return;

      this.notificationsLoading = true;
      try {
        return;
        const response = await this.$axios.get(
          `${this.BASE_URL_NOTIFICATION}/activities/list`,
          {
            headers: {
              "Content-Type": "application/json",
            },
            withCredentials: true,
          },
        );
        return;
        if (response.data && response.data.success && response.data.data) {
          this.notifications = response.data.data.list || [];
          // Update unseen counter
          this.unseen_message_counter = this.notifications.filter(
            (n) => !n.seenAt,
          ).length;
          // Reset message state
          this.showAllViewedMessage = false;
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
        // If 401, user not logged in, clear notifications
        if (error.response && error.response.status === 401) {
          this.notifications = [];
        }
      } finally {
        this.notificationsLoading = false;
      }
    },
    // Handle click on notification item
    async handleNotifyClick(notify) {
      // If not seen yet, mark as seen
      if (!notify.seenAt) {
        try {
          return;
          await this.$axios.post(
            `${this.BASE_URL_NOTIFICATION}/activities/seen`,
            { id: notify.id },
            {
              headers: {
                "Content-Type": "application/json",
              },
              withCredentials: true,
            },
          );

          // Update local state
          notify.seenAt = Math.floor(Date.now() / 1000);
          this.unseen_message_counter = this.notifications.filter(
            (n) => !n.seenAt,
          ).length;
        } catch (error) {
          console.error("Error marking notification as seen:", error);
        }
      }

      // If has articleLink, open it
      if (notify.data && notify.data.articleLink) {
        window.open(notify.data.articleLink, "_blank");
      }
    },
    // Format notification message with highlighted links
    formatNotifyMessage(notify) {
      let message = notify.message || "";

      // Determine link color based on title
      const linkColor =
        notify.title === "Thông tin giao dịch" ? "#10B981" : "#3B82F6";

      // For TRANSACTION type with packageCode
      if (
        notify.type === "TRANSACTION" &&
        notify.data &&
        notify.data.packageCode
      ) {
        const packageCode = notify.data.packageCode;
        // Try to find packageCode in message
        if (message.includes(packageCode)) {
          message = message.replace(
            new RegExp(
              packageCode.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
              "gi",
            ),
            `<strong style="color: ${linkColor};">${packageCode}</strong>`,
          );
        } else {
          // Try to find "gói XXX" pattern
          const packageMatch = message.match(/(gói\s+[^\.]+)/i);
          if (packageMatch) {
            message = message.replace(
              packageMatch[0],
              `<strong style="color: ${linkColor};">${packageMatch[0]}</strong>`,
            );
          }
        }
      }

      // For STAR_USAGE or COMMENT with articleLink
      if (
        (notify.type === "STAR_USAGE" ||
          notify.type === "COMMENT" ||
          notify.type === "SAVED_NEWS") &&
        notify.data &&
        notify.data.articleLink
      ) {
        // Try to extract article title from message
        // Pattern: "Bạn đã tặng 10 cho bài viết [article title]."
        const articleMatch = message.match(/cho bài viết[^\.]+/i);
        if (articleMatch) {
          const articleText = articleMatch[0]
            .replace(/cho bài viết\s*/i, "")
            .trim();
          if (articleText) {
            message = message.replace(
              articleText,
              `<strong style="color: ${linkColor};">${articleText}</strong>`,
            );
          }
        }

        // Add "Xem tin lưu" link at bottom
        message += `<br/><a href="${notify.data.articleLink}" target="_blank" style="color: #3B82F6; text-decoration: none; font-weight: 500;">Xem tin lưu</a>`;
      }

      return message;
    },
    // Format timestamp to DD/MM/YYYY HH:mm
    formatTime(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp * 1000);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes} ${day}/${month}/${year}`;
    },
    // Get icon based on notification type
    getNotifyIcon(type) {
      const iconMap = {
        TRANSACTION: `${this.BASE_URL_STATIC}/eduzone/images/TradeIcon.png`, // Trade icon for transactions
        STAR_USAGE: `${this.BASE_URL_STATIC}/eduzone/images/Vector123.png`, // Star icon
        COMMENT: `${this.BASE_URL_STATIC}/eduzone/images/megaphone.png`, // Speech bubble icon
        SAVED_NEWS: `${this.BASE_URL_STATIC}/eduzone/images/Vector123.png`, // Download/save icon
      };
      return iconMap[type] || `${this.BASE_URL_STATIC}/eduzone/images/megaphone.png`;
    },
    // View all notifications
    viewAllNotifications() {
      // If no notifications, show message
      if (this.notifications.length === 0) {
        this.showAllViewedMessage = true;
        // Hide message after 3 seconds
        setTimeout(() => {
          this.showAllViewedMessage = false;
          this.isNotifyDropdownOpen = false;
        }, 3000);
      } else {
        // Navigate to full notifications page or close dropdown
        this.isNotifyDropdownOpen = false;
        // TODO: Navigate to full page if exists
      }
    },
  },
};
